import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation, useSearchParams } from 'react-router-dom';

import Typography from "@mui/joy/Typography";
import Stack from "@mui/joy/Stack";
import Input from "@mui/joy/Input";
import Button from "@mui/joy/Button";


import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemContent from '@mui/joy/ListItemContent';

import getIcon from "utils/getIcon";
import useUserIdentity from "hooks/useUserIdentity";

import { Identity } from 'stores/identity_store';
import { SidebarLink } from 'components/Sidebar';
import IdentityAvatar from 'components/IdentityAvatar';
import Error from 'components/Error';

import { api_get, api_post } from 'api/utils';

export function SidebarIdentityLink({ identity }: { identity: Identity }) {
    const location = useLocation();
    const url = `/identity/${identity.uuid}`;
    const viewing = location.pathname === url;

    if(!identity) {
        return <em>Loading</em>;
    }
    return (
        <SidebarLink to={url} key={identity.key} >
            <ListItem>
                <ListItemButton
                            variant={viewing ? "soft" : undefined }
                            color={viewing ? "primary" : undefined } >
                    <ListItemContent>
                        <IdentityAvatar
                            size="inherit"
                            level="body-xs"
                            interactive={false}
                            identityKey={identity.uuid} />
                    </ListItemContent>
                </ListItemButton>
            </ListItem>
        </SidebarLink>
    );
}


export const SudoRedisAdmin = observer(() => {
    const [searchParams] = useSearchParams();

    const { currentIdentity } = useUserIdentity();
    const [search, setSearch] = useState(searchParams.get('search') || '');
    const [redisValue, setRedisValue] = useState('');
    const LabelImportant = getIcon('LabelImportant');

    const doFetch = () => {
        if(!search.length) {
            return Error("Search is empty");
        }
        console.log('doFetch redis_key', search);
        const params = {redis_key: search, identity: currentIdentity.uuid };
        api_get('/redis/get', params)
            .then(async (res) => {
                const data = await res.json();
                console.log('redis data', data);
                if(data && data.value) {
                    setRedisValue(data.value);
                }
                else {
                    Error('No data');
                }

            });
    };

    const deleteRedisKey = (key: string) => {
        if(!key.length) {
            return Error("No key");
        }
        console.log('deleteRedisKey', key);
        const params = {redis_key: key, identity: currentIdentity.uuid };
        api_post('/redis/delete', params)
            .then(async (res) => {
                const data = await res.json();
                console.log('redis data', data);
                if(data) {
                    setRedisValue('');
                    setSearch('');
                }
            });
    };
    // useEffect(() => {
    //     doFetch();
    // }, [doFetch]);

    return (
        <Stack m={1} spacing={2}>
            <Stack>
            <Typography level="title-lg"
            >
                Redis Admin
            </Typography>

            <Typography
                color="warning"
                startDecorator={<LabelImportant />}
                level="body-xs">
                Sudo Only
            </Typography>
            </Stack>
            <Stack
                spacing={1}
                pb={2}
            >
                Key: { search }

                <Input
                    placeholder="Search"
                    type="text"
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                />

                <Button
                    onClick={doFetch}
                    color="primary">
                    Search
                </Button>
            </Stack>

            {redisValue && redisValue.length &&
                <Stack
                    spacing={1}>
                    <Typography level="body-xs">
                        Value: {redisValue}
                    </Typography>
                    <Button
                        onClick={() => deleteRedisKey(search)}
                    >Delete</Button>
                </Stack>
            }

        </Stack>
    );
});

export default SudoRedisAdmin;
